import { map } from 'rxjs/operators';

import { setAuthRedirectPath } from '../shared/authRedirect';

import { checkAuth, logIn, logOut } from './api';
import { parseScopes } from './utils';

// Use a timestamped approach instead of a simple boolean
let redirectRequestTime = 0;
const REDIRECT_TIMEOUT = 5000;

export const authServices = {
  checkAuth: () =>
    checkAuth().pipe(
      map((response) => ({
        user_id: response.user_id,
        email: response.user_id,
        groups: response.groups,
        scopes: parseScopes(response.scopes),
      })),
    ),

  signIn: () => {
    const currentTime = Date.now();
    if (currentTime - redirectRequestTime < REDIRECT_TIMEOUT) {
      console.log('Auth redirect already in progress, ignoring additional request');
      return logIn();
    }
    redirectRequestTime = currentTime;
    setAuthRedirectPath();
    try {
      return logIn();
    } catch (error) {
      console.error('Authentication error:', error);
      redirectRequestTime = 0; // Reset flag on error
      throw error;
    }
  },

  signOut: () => logOut(),
};
